import { IRestorePassData } from "../../repository/IRestorePassData";

export const restorePass = (payload: IRestorePassData) => ({
  type: "@saga/RESTORE_PASS",
  payload,
});
